// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 1024px)";
var _3 = "(max-width: 1024px)";
var _4 = "screen and (max-width: 600px)";
var _5 = "header-Jef1w";
var _6 = "header__text-1hHfP";
var _7 = "header__inner-2w2a1";
export { _1 as "__esModule", _2 as "desktop_only", _3 as "tablet", _4 as "mobile", _5 as "header", _6 as "header__text", _7 as "header__inner" }
export default { "__esModule": _1, "desktop_only": _2, "tablet": _3, "mobile": _4, "header": _5, "header__text": _6, "header__inner": _7 }
